/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ brandName: NonNullable<unknown> }} Marketing_Hero_LedeInputs */

const en_marketing_hero_lede = /** @type {(inputs: Marketing_Hero_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.brandName} is a full-stack TypeScript starter on Cloudflare: auth, organizations, billing, a public API, realtime, AI, and background work. Wired together, typed end to end, and tested.`)
};

const es_marketing_hero_lede = /** @type {(inputs: Marketing_Hero_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.brandName} es un starter TypeScript full-stack sobre Cloudflare: autenticación, organizaciones, facturación, una API pública, tiempo real, IA y trabajo en segundo plano. Conectado, tipado de extremo a extremo y probado.`)
};

const fr_marketing_hero_lede = /** @type {(inputs: Marketing_Hero_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.brandName} est un starter TypeScript full-stack sur Cloudflare : authentification, organisations, facturation, API publique, temps réel, IA et traitement en arrière-plan. Assemblé, typé de bout en bout et testé.`)
};

/**
* | output |
* | --- |
* | "{brandName} is a full-stack TypeScript starter on Cloudflare: auth, organizations, billing, a public API, realtime, AI, and background work. Wired together, ..." |
*
* @param {Marketing_Hero_LedeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_hero_lede = /** @type {((inputs: Marketing_Hero_LedeInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Hero_LedeInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_hero_lede(inputs)
	if (locale === "es") return es_marketing_hero_lede(inputs)
	return fr_marketing_hero_lede(inputs)
});